import React, { ReactNode } from 'react';
import { Card, Alert, Form, Button, Stack } from 'react-bootstrap';
import { withParams } from '../helpers';
import { UploadTable } from '../models';
import { DefaultEditor } from 'react-simple-wysiwyg';
import API from '../APIClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const APIClient = new API();

interface Parameters { id: number; }
interface Props { params: Parameters; }
interface State { 
  title?: string
  text?: string
  id?: number
  images?: Array<UploadTable>
  validated?:boolean;
  error?:string; 
}

class Page extends React.Component <Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { title : "", text : "" }

    this.handleUpload = this.handleUpload.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.deleteImage = this.deleteImage.bind(this)

  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData(){
    APIClient.page(this.props.params.id).then((data) => {
      console.log(data)
      if(data.images) {
        data.images = data.images.length ? data.images : [data.images]
      }
      this.setState({ id: data.id, title: data.title, text: data.text, images: data.images })
    }).catch((e) => {
      window.location.href = "./login/2"
    })
  }

  handleChange(event:any){
    let value = event.target.value;
    let name = event.target.name;
    if(name || value){
      this.setState({[name]:value})
    }
  }

  handleUpload(event:any) {
    event.preventDefault();
    this.savePage();
    
    let data = {
      title : "test upload",
      text: "test",
      file : event.target.files[0]
    }

    APIClient.upload("pages", this.state.id ? this.state.id : 0, data).then((resp) => {
      this.fetchData()
    })

  }

  savePage() {
    let { title, text, id } = this.state
    return APIClient.updatePage({ id:id as number, text:text as string, title:title as string })
  }

  handleSubmit(event:any) {

    let { title, text } = this.state

    event.preventDefault();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    if(title && text){
      this.savePage().then((resp:any) => {
        this.setState({validated:true, error: undefined})
        if(this.state.id){
        window.location.href = `${APIClient.path}/paginas`
        }
      }).catch((error) => {
        this.setState({error:"Er ging iets mis tijdens het opslaan."})
      })
    }else{
      this.setState({error:"Verplichte velden"})
    }

  }

  deleteImage(id?:number){
    this.savePage().then(() => {
      APIClient.deleteUpload(id as number).then(() => {
        this.fetchData();
      })
    }) 
  }

  render() {


    let Uploads: Array<ReactNode> = []
    if(this.state.images) {
        this.state.images.forEach((image, index) => {
            let path = `${APIClient.website}${image.path}` 

            Uploads.push(<Card key={index} style={{maxWidth:"10vw"}}>
            <a href={path} target="_blank" rel="noreferrer"><Card.Img variant="top"src={path}  style={{maxWidth:"100%"}} /></a>
            <Card.Body>
              <Button variant="danger" size="sm" onClick={() => {this.deleteImage(image.id)}}> Delete </Button>
            </Card.Body>
            </Card>)
        })
    }

    return <Card>
      <Card.Header><FontAwesomeIcon icon="file" /> &nbsp;Pagina bewerken : {this.state.title}</Card.Header>
        <Card.Body>
          { this.state.validated && <Alert variant='success'>Wijzigingen succesvol opgeslagen!</Alert> }
          { this.state.error && <Alert variant='danger'>{this.state.error}</Alert> }
          <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
            <Form.Group>
              <Form.Label>Titel</Form.Label>
              <Form.Control type="title" onChange={this.handleChange} value={this.state.title} name="title" required />
            </Form.Group>

            <Form.Group>
              <Form.Label>Text</Form.Label>
              <DefaultEditor name="text" onChange={this.handleChange} value={this.state.text} style={{minHeight:"25vh"}}  />
            </Form.Group>


            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload</Form.Label>
              <Form.Control type="file" onChange={this.handleUpload}/>
            </Form.Group>

            <Form.Group>
              <Stack direction="horizontal" gap={2}>
              { Uploads }
              </Stack>
            </Form.Group>

            <br />
            <Button variant="primary" type="submit" onClick={this.handleSubmit}><FontAwesomeIcon icon="floppy-disk" /> <b>&nbsp;Opslaan</b></Button>
          </Form>
        </Card.Body>
    </Card>
  }
}



export default withParams(Page)